import { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { Card, Col, Row, Modal, Button } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import {
  deleteOtherType,
  getOtherType,
  // deleteOtherType, // 👈 nếu có API xoá thì mở ra
} from "../../../redux/action/otherType";
import { Category_Banner } from "../../../utils/formatType";
import { Link } from "react-router-dom";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const { confirm } = Modal;

function BannerCategory() {
  const { t } = useTranslation();
  const { otherTypeList } = useSelector((state) => state.otherType);

  const [loading, setLoading] = useState(true);

  /* ================= FETCH DATA ================= */
  const fetchData = () => {
    setLoading(true);
    dispatch(getOtherType(Category_Banner)).finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= DELETE ================= */
  const handleDelete = (e: React.MouseEvent, id: number) => {
    e.preventDefault(); // ⛔ chặn Link
    e.stopPropagation(); // ⛔ chặn bubble

    confirm({
      title: "Xác nhận xoá",
      content: "Bạn có chắc chắn muốn xoá banner này không?",
      okText: "Xoá",
      okType: "danger",
      cancelText: "Huỷ",
      onOk: async () => {
        try {
          await dispatch(deleteOtherType(id)); // 👈 gọi API xoá
          fetchData(); // reload list
        } catch (error) {
          console.error(error);
        }
      },
    });
  };

  /* ================= RENDER ================= */
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <TitleComponent
            title="Banner danh mục"
            type="primary"
            data="Tạo mới"
            icon={<PlusOutlined />}
            to="/Category/Banner/Create"
            isExist={true}
          />

          {otherTypeList.map((item, index) => (
            <Link to={`/Category/Banner/${item.id}`} key={item.id}>
              <Card
                className="layoutItem"
                style={{
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                {/* ===== NÚT XOÁ ===== */}
              

                <h3 style={{ color: "var(--primary-color)", marginBottom: 8 }}>
                  Banner {index + 1}
                </h3>

                <Row gutter={[20, 20]}>
                  {/* ===== TEXT ===== */}
                  <Col xs={24} md={12}>
                    <div>
                      <p className="tilteForm">{t("title")}</p>
                      <p className="descForm">{item.title}</p>
                    </div>

                    <div style={{ marginTop: 16 }}>
                      <p className="tilteForm">{t("Mô tả")}</p>
                      <p className="descForm">{item.description}</p>
                    </div>
                      <Button
                      style={{ marginTop: 30 }}
                  onClick={(e) => {
                    if (!item.id) return; // ⛔ chặn undefined
                    handleDelete(e, item.id);
                  }}
                  type="primary"                  
                >
                  Xoá Banner
                </Button>
                  </Col>

                  {/* ===== IMAGE ===== */}
                  <Col xs={24} md={12}>
                    {item.images?.[0] ? (
                      <img
                        src={item.images[0]}
                        alt="banner"
                        style={{
                          width: "100%",
                          height: 320,
                          borderRadius: 10,
                          marginTop: 14,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: 320,
                          marginTop: 14,
                          borderRadius: 10,
                          background: "#f0f0f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#999",
                          fontStyle: "italic",
                        }}
                      >
                        Không có ảnh
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            </Link>
          ))}
        </>
      )}
    </div>
  );
}

export default BannerCategory;
